import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import account from "./module/account";

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    account
  }
});
